// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ActivateLinksController from "./activate_links_controller"
application.register("activate-links", ActivateLinksController)

import AddressAutocompleteController from "./address_autocomplete_controller"
application.register("address-autocomplete", AddressAutocompleteController)

import AudioMessageController from "./audio_message_controller"
application.register("audio-message", AudioMessageController)

import AutohideController from "./autohide_controller"
application.register("autohide", AutohideController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import CartController from "./cart_controller"
application.register("cart", CartController)

import ChatReadController from "./chat_read_controller"
application.register("chat-read", ChatReadController)

import ChatSoundController from "./chat_sound_controller"
application.register("chat-sound", ChatSoundController)

import ClearInputController from "./clear_input_controller"
application.register("clear-input", ClearInputController)

import CommentFormController from "./comment_form_controller"
application.register("comment-form", CommentFormController)

import CountdownController from "./countdown_controller"
application.register("countdown", CountdownController)

import DealCardController from "./deal_card_controller"
application.register("deal-card", DealCardController)

import DealVideoOnlyController from "./deal_video_only_controller"
application.register("deal-video-only", DealVideoOnlyController)

import DealsFilterController from "./deals_filter_controller"
application.register("deals-filter", DealsFilterController)

import DebounceController from "./debounce_controller"
application.register("debounce", DebounceController)

import FirebaseController from "./firebase_controller"
application.register("firebase", FirebaseController)

import GeolocationController from "./geolocation_controller"
application.register("geolocation", GeolocationController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HowlerjsController from "./howlerjs_controller"
application.register("howlerjs", HowlerjsController)

import ImageUploadingController from "./image_uploading_controller"
application.register("image-uploading", ImageUploadingController)

import LocationPickerController from "./location_picker_controller"
application.register("location-picker", LocationPickerController)

import LoginController from "./login_controller"
application.register("login", LoginController)

import MapController from "./map_controller"
application.register("map", MapController)

import MediaPreviewController from "./media_preview_controller"
application.register("media-preview", MediaPreviewController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import PushNotificationController from "./push_notification_controller"
application.register("push-notification", PushNotificationController)

import ResetFormController from "./reset_form_controller"
application.register("reset-form", ResetFormController)

import ScrollController from "./scroll_controller"
application.register("scroll", ScrollController)

import ShareController from "./share_controller"
application.register("share", ShareController)

import SwipeableController from "./swipeable_controller"
application.register("swipeable", SwipeableController)

import UserLocationController from "./user_location_controller"
application.register("user-location", UserLocationController)

import VisibilityController from "./visibility_controller"
application.register("visibility", VisibilityController)
